import React, { PureComponent, useState, useCallback, Fragment } from 'react';
import { I } from '../../../common/v5/config';
import { BTN_TXT_SAVE, BTN_TXT_SAVING } from '../../../common/v5/constants';
import {
  TextInputRow,
  CheckboxInputRow,
} from '../../../reactcomponents/Form';
import {
  CancelButton,
  SaveButton,
  EditorFooter
} from '../../../reactcomponents/Admin';
import {
  LabelToggleSwitch as ToggleSwitch
} from '../../../components/v5/ToggleSwitch';
import { Tab, TabNav } from '../../../reactcomponents/Tabs';
import PttWidgetPreview from './pttWidgetPreview';

// Basic Configuration Component
const PttBasicConfig = ({
  input,
  onHandleTextInputChange,
  onHandleTextInputBlur,
  warning
}) => {
  return (
    <section className="ptt-basic-config">
      <div className="ptt-section-header">{I("Basic Configuration")}</div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Name")}<span className="mandatory-asterisk">*</span>:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.name || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'name',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Widget ID")}<span className="mandatory-asterisk">*</span>:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.widgetId || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'widgetId',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("SIP Queue ID")}<span className="mandatory-asterisk">*</span>:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.sipQueueId || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'sipQueueId',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Voice Server URL")}:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.voiceUrl || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'voiceUrl',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Customized")}:</label>
        <input
          className="ptt-input"
          type="checkbox"
          id={"pttWidget-customize"}
          name={"customize"}
          data-qa-id="customize"
          checked={input.customize || false}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'customize',
              value: e.target.checked
            }
          })}
        />
      </div>
    </section>
  );
};

// Appearance Configuration Component
const PttAppearanceConfig = ({
  input,
  onHandleTextInputChange,
  onHandleTextInputBlur
}) => {
  return (
    <div className="ptt-appearance-config">
      <div className="ptt-section-header">{I("Appearance")}</div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Button Text")}:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.buttonText || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'buttonText',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
      <div className="ptt-input-row">
        <label className="ptt-label">{I("Button Color")}:</label>
        <input
          className="ptt-input form-control"
          type="text"
          value={input.buttonColor || ""}
          onChange={(e) => onHandleTextInputChange({
            target: {
              name: 'buttonColor',
              value: e.target.value
            }
          })}
          onBlur={onHandleTextInputBlur}
        />
      </div>
    </div>
  );
};

export default class PttWidgetConfigForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      selectedTab: 'Preview'
    };
    this.handleChangeData = this.handleChangeData.bind(this);
    this.handleChangeToggle = this.handleChangeToggle.bind(this);
    this.handleExpandToggle = this.handleExpandToggle.bind(this);
    this.setSelectedTab = this.setSelectedTab.bind(this);
  }

  handleChangeData = (e) => {
    this.props.onHandleTextInputChange(e);
  };

  handleChangeToggle = (value, field) => {
    this.props.onHandleTextInputChange({
      target: {
        name: field,
        value: value
      }
    });
  };

  handleExpandToggle = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }));
  };

  setSelectedTab = (tab) => {
    this.setState({ selectedTab: tab });
  };

  checkFields = () => {
    const { input } = this.props;
    return input.widgetId && input.sipQueueId;
  };

  handleSavePttWidget = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (this.checkFields()) {
      const { input, activeId } = this.props;
      let params = {
        id: activeId,
        name: input.name,
        widgetId: input.widgetId,
        sipQueueId: input.sipQueueId,
        voiceUrl: input.voiceUrl,
        customize: input.customize || false,
        buttonText: input.buttonText,
        buttonColor: input.buttonColor
      };
      this.props.onSaveAdmin(params);
    }
  };

  renderCode = () => {
    const { input } = this.props;
    
    const widgetId = input.widgetId || 'your_widget_id';
    const sipQueueId = input.sipQueueId || 'your_sip_queue_id';
    const voiceUrl = input.voiceUrl || 'voice1.cention.com';
    const buttonText = input.buttonText || 'Push to Talk';
    const buttonColor = input.buttonColor || 'blue';
    const buttonSize = input.buttonSize || 'medium';

    let code = `<body>\n`;
    code += `    <div class="container">\n`;
    code += `        <div id="pushToTalkContainer"></div>\n`;
    code += `        <audio id="CentionCallAudio"\n`;
    code += `            hidden={true}\n`;
    code += `            loop={true}\n`;
    code += `            autoPlay\n`;
    code += `        />\n`;
    code += `    </div>\n\n`;
    code += `    <script src="https://static.cention.com/sg/chat/js/ppt-widget.js" type="text/javascript"></script>\n\n`;
    code += `    <script>\n`;
    code += `        // Example configuration\n`;
    code += `        const widgetId = '${widgetId}';\n`;
    code += `        const workspaceName = 'cention';\n`;
    code += `        \n`;
    code += `        // Global variables that PushToTalk depends on\n`;
    code += `        window.CentionApidURL = 'https://apid.cention.com';\n`;
    code += `        window.CentionVoiceURL = '${voiceUrl}';\n`;
    code += `        window.CentionVoiceQueue = '${sipQueueId}';\n\n`;
    code += `        // Create PushToTalk instance\n`;
    code += `        const pushToTalk = new PushToTalk(widgetId, workspaceName, '${buttonText}', '${buttonColor}');\n`;
    code += `        \n`;
    code += `        // Add the button to the container\n`;
    code += `        document.getElementById('pushToTalkContainer').appendChild(pushToTalk.getButton());\n`;
    code += `        \n`;
    code += `        // Example of how to handle cleanup when the page is unloaded\n`;
    code += `        window.addEventListener('beforeunload', async () => {\n`;
    code += `            await pushToTalk.destroy();\n`;
    code += `        });\n`;
    code += `    </script>\n`;
    code += `</body>`;

    return code;
  };

  render() {
    const { input, warning, onCancel, onSave, isSaving } = this.props;
    const { isExpanded, selectedTab } = this.state;

    const tabs = ['Preview', 'Code'];

    return (
      <div className="admin-one-form widget-label-block ptt-widget-config">
        <div className="ptt-config-container">
          {/* Left side - Configuration */}
          <div className="ptt-config-left">
            <PttBasicConfig
              input={input}
              onHandleTextInputChange={this.handleChangeData}
              onHandleTextInputBlur={this.props.onHandleTextInputBlur}
              warning={warning}
            />
            {input.customize && (
              <>
                <hr className="section-separator" />
                <PttAppearanceConfig
                  input={input}
                  onHandleTextInputChange={this.handleChangeData}
                  onHandleTextInputBlur={this.props.onHandleTextInputBlur}
                />
              </>
            )}
          </div>

          {/* Right side - Preview/Code */}
          <div className="ptt-config-right">
            <TabNav tabs={tabs} selected={selectedTab} setSelected={this.setSelectedTab}>
              <Tab isSelected={selectedTab === 'Preview'}>
                <div className="ptt-preview-container">
                  <PttWidgetPreview
                    input={input}
                    isExpanded={isExpanded}
                  />
                </div>
              </Tab>
              <Tab isSelected={selectedTab === 'Code'}>
                <div className="ptt-code-preview">
                  <div id="cell-preview-body-ptt-widget">
                    <textarea 
                      data-qa-id={"textarea-field-input-preview"} 
                      className={"preview-body"} 
                      value={this.renderCode()} 
                      disabled={true}
                    />
                  </div>
                </div>
              </Tab>
            </TabNav>
          </div>
        </div>

        <EditorFooter>
          <CancelButton onClick={onCancel} />
          <SaveButton
            onClick={this.handleSavePttWidget}
            disabled={!this.checkFields() || isSaving}
            isSaving={isSaving}
            buttonText={isSaving ? BTN_TXT_SAVING : BTN_TXT_SAVE}
          />
        </EditorFooter>
      </div>
    );
  }
} 
